import React from 'react'
import ImageContainer from '../image-container/image-container.component'
import { RandomString } from '@/utils/randomString'
import { useGameTerms } from '@/utils/gameTerms'

const ElementAttributesPreview = ({
  element
}) => {
  const terms = useGameTerms()
  return (
    <div>
      {
        (element.type === 'leaderboard')
          ?
          <div className='element-attributes'>
            <div className='meta'>
              <b>Player Count:</b> {element.count}
            </div>
            <div className='meta'>
              <b>Names:</b> {
                (element.indOrTeams === 'individuals' && element.nameDisplay === 'full')
                  ?
                  'Individual Full Names'
                  :
                  (element.indOrTeams === 'individuals' && element.nameDisplay === 'display')
                    ?
                    'Individual Display Names'
                    :
                    (element.indOrTeams === 'individuals' && element.nameDisplay === 'secret')
                      ?
                      'Individual Aliases'
                      :
                      (element.indOrTeams === 'teams')
                        ?
                        `${terms.team.singular} Names`
                        :
                        ''
              }
            </div>
            <div className='meta'>
              <b>Data Displayed:</b> {
                (!element.totals)
                  ?
                  'No Data Displayed'
                  :
                  (element.data === 'points')
                    ?
                    'Total XP'
                    :
                    (element.data === 'currency')
                      ?
                      `Current ${terms.currency.singular} Balance`
                      :
                      (element.data === 'currencyTotal')
                        ?
                        `Total ${terms.currency.plural} Earned`
                        :
                        ''
              }
            </div>
          </div>
          :
          (
            element.type === 'item' || 
            element.type === 'badge' || 
            element.type === 'challenge'
          )
            ?
            <div className='element-attributes'>
              {
                (element.opt_itemType) &&
                <div className='meta'>
                  <b>Item Type:</b> {
                    (element.opt_itemType === 'inventory')
                      ?
                      'Game Inventory Item'
                      :
                      (element.opt_itemType === 'realworld')
                        ?
                        'Real World Item'
                        :
                        (element.opt_itemType === 'collectible')
                          ?
                          'Collectible Item'
                          :
                          (element.opt_itemType === 'lottery')
                            ?
                            'Lottery Ticket'
                            :
                            (element.opt_itemType === 'contribution')
                              ?
                              'Contribution Item'
                              : ''
                  }
                </div>
              }
              {
                (element.opt_cat) &&
                <div className='meta'>
                  <b>Category:</b> {element.opt_cat}
                </div>
              }
              {
                (element.opt_market) &&
                <div className='meta'>
                  <b>For Sale in the Market:</b> {element.opt_market === true ? 'Yes' : 'No'}
                </div>
              }
              {
                (element.opt_marketPrice) &&
                <div 
                  className='meta'
                  style={{"display": "flex", "alignItems": "center", "gap": 4}}>
                  <b>Market Price:</b> <ImageContainer 
                    src="/images/icons/coin.png"
                    style={{"width": 10, "height": 10}} /> {element.opt_marketPrice.toLocaleString()}
                </div>
              }
              {
                (element.opt_usable) &&
                <div className='meta'>
                  <b>Able to be Turned In:</b> {element.opt_usable === true ? 'Yes' : 'No'}
                </div>
              }
              {
                (element.opt_itemList && element.opt_itemList.length > 0) &&
                <div className='meta'>
                  <b>Item Count:</b> {element.opt_itemList.length}
                </div>
              }
              {
                (element.opt_contributionGoal) &&
                <div 
                  className='meta'
                  style={{"display": "flex", "alignItems": "center", "gap": 4}}>
                  <b>Contribution Goal:</b> <ImageContainer 
                    src="/images/icons/coin.png"
                    style={{"width": 10, "height": 10}} /> {element.opt_contributionGoal.toLocaleString()}
                </div>
              }
              {
                (element.rewards && element.rewards.length > 0) &&
                <div className='meta'>
                  <b>Rewards:</b>
                  <div style={{"paddingLeft": 10}}>{
                    element.rewards
                    .map((reward, index) => (
                      <div key={index + RandomString(5)} >
                        {reward}
                      </div>
                    ))
                  }</div>
                </div>
              }
            </div>
            : ''
      }
    </div>
  )
}

export default ElementAttributesPreview